import React, { useEffect, useState } from "react";
import { getResponsiveImage } from "../../utils/imageHelper";


/* eslint-disable */

interface BannerComponentProps {
  multicotizadorData?: any;
  customImage?: string;
  children?: React.ReactNode;
}

declare const window: any;

const BannerComponent: React.FC<BannerComponentProps> = ({ multicotizadorData, customImage, children }) => {
  const [isPortrait, setIsPortrait] = useState(false);
  const [imageLoaded, setImageLoaded] = useState(false);
  const [imageUrl, setImageUrl] = useState<string>("");

  useEffect(() => {
    const mediaQuery = window.matchMedia("(orientation: portrait)");

    const updateOrientation = () => {
      setIsPortrait(mediaQuery.matches);
    };

    updateOrientation();
    mediaQuery.addEventListener("change", updateOrientation);

    return () => {
      mediaQuery.removeEventListener("change", updateOrientation);
    };
  }, []);

  useEffect(() => {
    let url = "";
    if (customImage) {
      url = customImage;
    } else if (multicotizadorData && multicotizadorData.length > 0) {
      const path = isPortrait ? multicotizadorData[0]?.banner_portrait?.url : multicotizadorData[0]?.banner?.url;
      url = getResponsiveImage(path || '').desktop;
    }


    if (url) {
      setImageUrl(url);
      setImageLoaded(false);

      const img = new Image();
      img.onload = () => setImageLoaded(true);
      img.src = url;
    }
  }, [customImage, multicotizadorData, isPortrait]);

  return (
    <div
      className={`banner-multi-cotizacion-component ${!imageLoaded && imageUrl ? "loading" : ""}`}
      style={{
        backgroundImage: imageLoaded ? `url(${imageUrl})` : "none",
        backgroundColor: !imageLoaded && imageUrl ? "#e0e0e0" : "transparent",
      }}
    >
      {children}
    </div>
  );
};

export default BannerComponent;
